import React from 'react'

interface Props {
  time: string
}

class DisplayTime extends React.Component<Props> {
   
    render() {
      return (
          <div>
            {this.props.time}
          </div>
      );
    }

}

export default DisplayTime;  